import { render, staticRenderFns } from "./ItemImage.vue?vue&type=template&id=0ba228b8&scoped=true&"
import script from "./ItemImage.vue?vue&type=script&lang=js&"
export * from "./ItemImage.vue?vue&type=script&lang=js&"
import style0 from "./ItemImage.vue?vue&type=style&index=0&id=0ba228b8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba228b8",
  null
  
)

export default component.exports